export default __webpack_public_path__ + "static/media/logo1.77ac16c6.PNG";